
import React, { useContext, useEffect, useState } from "react";
import "./Blogs.css";
import { useNavigate } from "react-router-dom";
import { Context } from "../../utils/context";
import { getAllBlog } from "../../utils/apis/blog/Homeapi";
import { decodeId, encodeId, timeAgoOrDate } from "../../utils/common";

const Blogs = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [blogs, setBlogs] = useState();

  const blogsPerPage = 10;

  const handleBlogClick = (blog) => {
    navigate(`/blog/${encodeId(blog.id)}`);
  };
  const {
    IMG_URL,
    appSetup
  } = useContext(Context);



  const getAllBlogs = async () => {
    const res = await getAllBlog({
      page: currentPage,
      per_page: blogsPerPage,
    });

    if (res?.success) {
      setBlogs(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllBlogs();
  }, [currentPage]);


  const totalPages = blogs?.total_pages || 1;


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <section className="Blogs About_Banner">
      <div className="container-fluid">
        <div className='About_Banner_holder detail_banner'>
          <img src='/assets/images/about-us/about_banner.png' className='banner' />
          <div className="name_holder">
            <h5 className="about_us">Blogs</h5>
          </div>
        </div>


        <div className="container">
          <div className="blog_cards_section">
            <div className="row">
              {blogs?.data?.map((blog) => (
                <div className="col-lg-4 col-md-6 col-sm-6 mb-4" key={blog.id}>
                  <div
                    className="blog_card"
                    onClick={() => handleBlogClick(blog)}
                  >
                    <div className="blog_img_wrapper">
                      <img src={IMG_URL + blog.image} alt="blog" className="blog_img" />
                    </div>
                    <div className="blog_overlay">
                      <h5 className="blog_title">{blog.blog_name || " "}</h5>
                      <div className="blog_footer">
                        <span className="blog_date">{timeAgoOrDate(blog?.createdAt)}</span>
                        <span className="blog_link">Start Reading</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            <div className="pagination_wrapper">
              <button
                className="page_btn arrow_btn"
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                &#8249;
              </button>

              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`page_btn ${currentPage === index + 1 ? "active" : ""
                    }`}
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              ))}

              <button
                className="page_btn arrow_btn"
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                &#8250;
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blogs;
